import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
	MatterMortgage,
	MatterMortgageWithAssociations,
} from '@models/mortgage';
import { MatterMortgageDispatch } from '@state/matter/matter_mortgages';

@Component({
	selector: 'app-closer-sync-mortgage-funder',
	templateUrl: './closer-sync-mortgage-funder.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncMortgageFunderComponent {
	@Input() set mortgage(_mortgage: MatterMortgage) {
		this._mortgage = _mortgage;
	}

	public _mortgage: MatterMortgage;

	constructor(private mortgageDispatch: MatterMortgageDispatch) {}

	setLenderContactName(value: string) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			lenderContactName: value,
		});
	}

	setLenderContactPhoneNumber(value: string) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			lenderContactPhoneNumber: value,
		});
	}

	setLenderContactEmail(value: string) {
		this.mortgageDispatch.updateMortgage(this._mortgage.id, {
			lenderContactEmail: value,
		});
	}
}
